import React from "react";
import Modal from "../../../Modal/Modal";
import Button from "../../../Buttons/Button";

const DeleteInvoice = ({ onClose, isOpen }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="DELETE CONFORMATION"
      width="max-w-3xl"
    >
      <div className="px-4">
        <div>
          <p>You are about to delete an invoice with the following outcome</p>
          <ol className="list-disc list-inside ml-3">
            <li>
              All the Timesheets and Expenses linked with the invoice will be
              reset to non-invoiced.
            </li>
            <li>
              If the invoice has any payments, the amount will be credited back
              to the Client’s credit balance.
            </li>
          </ol>
          <p>Are you sure you want to delete the invoice ?</p>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <Button title={"No"} variant="outlined" onClick={onClose} />
          <Button title={"Yes"} onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteInvoice;
